module.exports = __webpack_public_path__ + "img/Icon-Announcements.cce8957e.svg";